import { unstable_ClassNameGenerator as ClassNameGenerator } from '@liquidweb-dev/undercurrent/className';

ClassNameGenerator.configure((componentName) =>
	componentName.replace('Mui', 'UC'),
);
